import { render, staticRenderFns } from "./InformationScolaireComponent.vue?vue&type=template&id=0849912f&scoped=true"
import script from "./InformationScolaireComponent.vue?vue&type=script&lang=js"
export * from "./InformationScolaireComponent.vue?vue&type=script&lang=js"
import style0 from "./InformationScolaireComponent.vue?vue&type=style&index=0&id=0849912f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0849912f",
  null
  
)

export default component.exports